(function ($, Drupal) {
    // Initiate the Drupal autocomplete made in core/misc/autocomplete.js
    var autocomplete = Drupal.autocomplete;

    var selectedItemsWithRefId = [];
    var selectedItemsWithoutRefIds = [];
    /**
     * Handles an autocomplete select event.
     */
    function selectHandlerCustom(event, ui) {
        selectedItemsWithoutRefIds = autocomplete.splitValues(event.target.value);
        selectedItemsWithoutRefIds.pop();

        /**
         * ui.item.label -> contains the item name without the reference id
         * ui.item.value -> contains the item name with the reference id
         */
        selectedItemsWithoutRefIds.push(ui.item.label);
        selectedItemsWithRefId.push({label: ui.item.label, value: ui.item.value});

        /* change the value of autoselect widget to display the selectedItemsWithoutRefsIds */
        event.target.value = selectedItemsWithoutRefIds.join(', ');
        return false;
    }

    // Override the select handler initiated in core/misc/autocomplete.js
    Drupal.autocomplete.options.select = selectHandlerCustom;

    /*
     * Before submitting the form, we replace the autocomplete widget values with items that contain reference id
     */
    $("#node-ms-upload-reports-form,#node-ms-upload-reports-edit-form").submit(function () {
        // we filter out those items that the user may have removed
        var selectedItems = selectedItemsWithRefId
                .filter(function (item) {
                    return selectedItemsWithoutRefIds.includes(item.label);
                }).map(function (item) {
            return item.value;
        });

    });
})(jQuery, Drupal);

$(document).ready(function () {
    var country = $("#edit-field-ms-0-target-id").val().split(" (");
    $("#edit-field-ms-0-target-id").val(country['0']);
});

    